
import './App.css';

import AllRoutes from './Router/Allroutes';
function App() {
  return (
    <div className="App">
  <AllRoutes/>
    </div>
  );
}
export default App


